import m from "../../geodata/es2015/southAfricaHigh";
window.am4geodata_southAfricaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/southAfricaHigh.js
// module id = null
// module chunks = 